import { Component, OnInit } from '@angular/core';
import { faAngleRight } from '@fortawesome/free-solid-svg-icons';
import { environment } from '@rensa/environments/environment';
import { Router } from '@angular/router';
import { RoleService } from '@rensa/shared/services/role.service';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.css']
})
export class MenuComponent implements OnInit {

  faAngleRight = faAngleRight;
  menuItems = environment.menuItems;
  roles: string[];

  constructor(private router: Router, private rolesService: RoleService) {
  }

  get isAdmin(): boolean {
    return this.roles?.indexOf(environment.roles.cms) > -1;
  }

  get isHost(): boolean {
    return this.roles?.indexOf(environment.roles.host) > -1;
  }

  ngOnInit(): void {
    if (localStorage.length > 0) {
      this.rolesService.fetchAll().subscribe(roles => {
        this.roles = roles;
      });
    }
  }

  isExternal(url: string): boolean {
    return url.startsWith('http');
  }

  navigate(url: string): void {
    if (this.isExternal(url)) {
      window.location.href = url;
    } else {
      this.router.navigate([url]);
    }
  }
}
